import { styled } from "styled-components";

export const StyledLandingText = styled.p`
  font-size: 1.1rem;
  line-height: 1.6rem;
  margin: 1rem 0;
`;
